import { Link } from 'react-router-dom';
import useScrollAnimation from '../hooks/useScrollAnimation';
import img1 from '../imagesForCategory/Wedding/Wed 03.jpg';
import img2 from '../imagesForCategory/Prewedding/Prew 02.jpg';
import img3 from '../imagesForCategory/Haldi/Ha 03.jpg';
import img4 from '../imagesForCategory/Bride & groom/Br 04.jpg';
import img5 from '../imagesForCategory/Engagement/En 03.jpg';
import img6 from '../imagesForCategory/Reception/Re 03.jpg';
import imgBaby from '../imagesForCategory/Birthday/B 01.jpg';
import imgFamily from '../imagesForCategory/Stills/Sti 03.jpg';
import imgMaternity from '../imagesForCategory/Maternity/Ma 01.jpg';
import parallaxImg from '../imagesForCategory/Wedding/Wed 08.jpg';

const stats = [
  { number: '35+', label: 'Years of Legacy' },
  { number: '10,000+', label: 'Happy Families' },
  { number: '3', label: 'Studio Branches' },
  { number: '50+', label: 'Team Members' },
];

const whyChooseUs = [
  'Experienced in Indian wedding traditions',
  'Experience in family & celebration events',
  'Professional cameras & high-end cinematic equipment',
  'Friendly team that blends seamlessly with guests',
  'Personalized approach for every couple',
  'Creative & experienced photography team',
  'Calm, friendly approach during ceremonies',
  'Premium editing & timely delivery',
  'Expertise in baby, kids & family photography',
  'Comfortable, stress-free experience',
  'Professional studio setup & lighting',
  'Neat, hygienic & well-maintained studio',
  'Quick service with quality results',
];

const whyParentsTrust = [
  { title: 'Experienced in handling newborns', desc: 'Our team has years of expertise working with babies of all ages, ensuring safe and beautiful shots.' },
  { title: 'Patient, caring & trained team', desc: 'We never rush — every session moves at the baby\'s pace with gentle, caring hands.' },
  { title: 'High hygiene & safety standards', desc: 'Thoroughly sanitized props, wraps & equipment for every session.' },
  { title: 'Clean and hygienic equipment', desc: 'Soft, baby-safe fabrics and materials maintained to the highest standards.' },
  { title: 'Patient team experienced with children', desc: 'We know how to capture natural smiles and playful moments with little ones.' },
  { title: 'Flexible timing to suit the baby\'s mood', desc: 'We schedule around your child\'s comfort — their mood always comes first.' },
];

const services = [
  { title: 'Wedding Photography & Videography', desc: 'Candid, natural storytelling of your special day — emotional rituals, joyful celebrations, and quiet intimate moments, documented as they unfold.' },
  { title: 'Pre-Wedding Shoots', desc: 'Unique, artistic love stories with creative lighting — from soft natural light to dramatic cinematic setups.' },
  { title: 'Maternity Shoots', desc: 'Feel-good, natural images celebrating motherhood with soft lighting and thoughtful compositions.' },
  { title: 'Haldi Ceremony', desc: 'Turmeric hues, playful rituals, heartfelt blessings — captured in their purest, most joyful form.' },
  { title: 'Bridal & Groom Ceremonies', desc: 'Two journeys, one beautiful beginning — artistic photography of graceful preparations and confident charm.' },
  { title: 'Newborn Photography', desc: 'Gentle, safe, hygienic shoots handled with utmost sensitivity — your baby\'s comfort always comes first.' },
  { title: '1st Birthday & Pre-Birthday', desc: 'Cake smashes, playful moments, themed concepts — celebrating milestones with vibrant, joyful imagery.' },
  { title: 'Daily Activity Shoots', desc: 'Natural routines turned into beautiful memories — playing, laughing, crawling, walking, family time.' },
  { title: 'Saree Ceremony', desc: 'A graceful tradition captured forever — rituals, elegant portraits, family blessings in vibrant detail.' },
  { title: 'Wedding Anniversary', desc: 'Celebrating love that grows stronger — from 1st to Golden anniversaries, every milestone told beautifully.' },
  { title: 'Family Photography', desc: 'Natural emotions and genuine connections — parent-child bonding, generational photos, lifestyle shoots.' },
  { title: 'Portraits & Passport Photos', desc: 'Professional, precise studio portraits and government-approved passport & ID photos with instant service.' },
];

export default function About() {
  useScrollAnimation();

  return (
    <main>
      {/* ═══ OUR STORY ═══ */}
      <section className="py-28 md:py-36 bg-charcoal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="fade-left">
              <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">Who We Are</p>
              <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-6">
                Trusted by <span className="italic text-gold">Generations</span>
              </h2>
              <div className="gold-line-left mb-8" />
              <p className="text-cream/65 leading-[1.9] font-light text-sm md:text-base mb-6">
                With a legacy that began in <strong className="text-gold font-medium">1989</strong>, we are proud to be a complete
                photography and videography service provider, trusted by generations of families. Our expertise spans
                <strong className="text-cream/80"> photography, videography, cinematic videography, photo album designing, and professional video editing</strong>,
                delivering high-quality visuals that beautifully preserve life's most meaningful moments.
              </p>
              <p className="text-cream/65 leading-[1.9] font-light text-sm md:text-base mb-6">
                We specialize in capturing celebrations with creativity, emotion, and precision. From
                pre-wedding shoots, weddings, and receptions to birthday events, pre-birthday shoots, saree
                ceremonies, seemantham, cradle ceremonies, and retirement functions, we cover every
                occasion with the same passion and attention to detail.
              </p>
              <p className="text-cream/65 leading-[1.9] font-light text-sm md:text-base">
                Our cinematic videography transforms real moments into timeless films, while our custom-designed
                photo albums tell your story in an elegant and memorable way. With decades of experience, we
                understand traditions, emotions, and the importance of every ritual, ensuring nothing is missed.
              </p>
            </div>
            <div className="fade-right">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <div className="album-card rounded overflow-hidden">
                    <img src={img1} alt="Wedding" className="w-full aspect-[3/4] object-cover" />
                  </div>
                  <div className="album-card rounded overflow-hidden">
                    <img src={img3} alt="Haldi" className="w-full aspect-square object-cover" />
                  </div>
                </div>
                <div className="space-y-4 mt-8">
                  <div className="album-card rounded overflow-hidden">
                    <img src={img2} alt="Pre Wedding" className="w-full aspect-square object-cover" />
                  </div>
                  <div className="album-card rounded overflow-hidden">
                    <img src={img4} alt="Bride" className="w-full aspect-[3/4] object-cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ STATS ═══ */}
      <div className="section-divider" />
      <section className="py-20 bg-charcoal-light">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 stagger">
            {stats.map((stat, i) => (
              <div key={i} className="fade-up text-center py-8 px-4 border border-gold/8 rounded hover:border-gold/25 transition-colors duration-500">
                <p className="font-playfair text-3xl md:text-4xl gold-text mb-2">{stat.number}</p>
                <p className="text-cream/50 text-[10px] tracking-[0.2em] uppercase font-montserrat">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="section-divider" />

      {/* ═══ PHILOSOPHY ═══ */}
      <section
        className="parallax-section py-28 md:py-36"
        style={{ backgroundImage: `url(${parallaxImg})` }}
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center fade-up">
          <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-4">Our Philosophy</p>
          <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-10">
            More Than <span className="italic text-gold">Photography</span>
          </h2>
          <p className="text-cream/80 text-xl md:text-2xl leading-[1.8] font-light font-cormorant italic mb-8">
            "At every event, our focus is on creating natural, vibrant, and heartfelt visuals that you can
            cherish for a lifetime. Combining modern techniques with years of expertise, we are committed
            to delivering exceptional service, creativity, and lasting memories."
          </p>
          <div className="gold-line" />
        </div>
      </section>

      {/* ═══ WHY CHOOSE US ═══ */}
      <section className="py-28 md:py-36 bg-charcoal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 fade-up">
            <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">What Sets Us Apart</p>
            <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-6">
              Why Choose <span className="italic text-gold">Us</span>
            </h2>
            <div className="gold-line" />
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-5 stagger">
            {whyChooseUs.map((item, i) => (
              <div key={i} className="fade-up flex items-center gap-4 py-4 border-b border-gold/6 group hover:border-gold/20 transition-colors">
                <span className="w-2 h-2 rounded-full bg-gold shrink-0 group-hover:scale-125 transition-transform" />
                <span className="text-cream/65 text-sm font-light">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* ═══ WHY PARENTS TRUST US ═══ */}
      <section className="py-28 md:py-36 bg-charcoal-light">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="order-2 md:order-1 fade-left">
              <div className="grid grid-cols-2 gap-4">
                <div className="album-card rounded overflow-hidden">
                  <img src={imgBaby} alt="Baby photography" className="w-full aspect-[4/5] object-cover" />
                </div>
                <div className="album-card rounded overflow-hidden mt-8">
                  <img src={imgMaternity} alt="Maternity photography" className="w-full aspect-[4/5] object-cover" />
                </div>
              </div>
            </div>
            <div className="order-1 md:order-2 fade-right">
              <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">For Little Ones</p>
              <h2 className="font-playfair text-3xl md:text-4xl text-cream mb-6">
                Why Parents <span className="italic text-gold">Trust Us</span>
              </h2>
              <div className="gold-line-left mb-8" />
              <div className="space-y-6">
                {whyParentsTrust.map((item, i) => (
                  <div key={i} className="group">
                    <h4 className="text-cream/85 text-sm font-medium mb-1 flex items-center gap-3">
                      <svg className="w-4 h-4 text-gold shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {item.title}
                    </h4>
                    <p className="text-cream/45 text-xs leading-relaxed ml-7">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* ═══ OUR SERVICES ═══ */}
      <section className="py-28 md:py-36 bg-charcoal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 fade-up">
            <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">What We Offer</p>
            <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-6">
              Our <span className="italic text-gold">Services</span>
            </h2>
            <div className="gold-line mb-6" />
            <p className="text-cream/50 max-w-2xl mx-auto text-sm font-light">
              From grand weddings to intimate family portraits, we cover every occasion with the same passion and attention to detail.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 stagger">
            {services.map((service, i) => (
              <div key={i} className="fade-up p-7 border border-gold/8 rounded hover:border-gold/20 transition-all duration-500 group">
                <div className="flex items-start gap-3 mb-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold mt-2 shrink-0" />
                  <h3 className="font-playfair text-base text-cream group-hover:text-gold transition-colors">{service.title}</h3>
                </div>
                <p className="text-cream/45 text-xs leading-relaxed ml-[18px]">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ GALLERY STRIP ═══ */}
      <section className="py-4 bg-charcoal-light overflow-hidden">
        <div className="flex gap-4 animate-[scroll_30s_linear_infinite]" style={{ width: 'max-content' }}>
          {[img1, img2, img3, img4, img5, img6, imgBaby, imgFamily, imgMaternity, img1, img2, img3, img4, img5, img6].map((img, i) => (
            <div key={i} className="w-48 h-32 shrink-0 rounded overflow-hidden opacity-60 hover:opacity-100 transition-opacity">
              <img src={img} alt="" className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </section>

      {/* ═══ CTA ═══ */}
      <section className="py-28 md:py-36 bg-charcoal">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center fade-up">
          <p className="text-gold text-xs tracking-[0.3em] uppercase font-montserrat mb-3">Let's Work Together</p>
          <h2 className="font-playfair text-4xl md:text-5xl text-cream mb-6">
            Ready to Create <span className="italic text-gold">Memories?</span>
          </h2>
          <div className="gold-line mb-8" />
          <p className="text-cream/60 text-base md:text-lg mb-12 max-w-2xl mx-auto font-light">
            Whether it's a grand wedding or an intimate family portrait, we're here to capture your story beautifully.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="btn-gold">Contact Us</Link>
            <Link to="/wedding" className="btn-outline">View Our Work</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
